import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import type {
  GetProcessorInstancesByAgentQuery,
  GetProcessorInstancesByAgentQueryVariables,
} from '#graphql/generated';

export const GET_PROCESSOR_INSTANCES_BY_AGENT: TypedDocumentNode<
  GetProcessorInstancesByAgentQuery,
  GetProcessorInstancesByAgentQueryVariables
> = gql`
  query GetProcessorInstancesByAgent($agentId: String!, $limit: Int) {
    processorInstancesByAgent(agentId: $agentId, limit: $limit) {
      id
      processorId
      userId
      status
      runLogAvailable
      metadata
      error
      createdAt
      updatedAt
    }
  }
`;
